function Offercard({Offer}) {
    console.log(Offer)
  const renderList = () => {
    return (
      <ul>
        {Offer.services.map((service, index) => (
          <li>{service}</li>
        ))}
      </ul>
    );
  };
  return (
    <div className="row">
      <div className="rounded-box">
        <div className="boxheader">
          <img className="serviceImage" src={Offer.img} width={80} />
          <h3>{Offer.title} </h3>
        </div>
        {Offer.description}
        <ul>{renderList()}</ul>
      </div>
    </div>
  );
}

export default Offercard;
